import { z } from "zod";

import { passwordSchema } from "./password";

export const ChangePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Current password can not be blank"),
    newPassword: passwordSchema,
    confirmPassword: z.string().min(1, "Please confirm your new password"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  })
  .refine((data) => data.newPassword !== data.currentPassword, {
    message: "New password must be different from the current password",
    path: ["newPassword"],
  });
